export default __webpack_public_path__ + "static/media/gallery-wip-control-box_00.fd40040e.jpg";